import { render, staticRenderFns } from "./orderDetail.vue?vue&type=template&id=2dc24957&scoped=true"
import script from "./orderDetail.vue?vue&type=script&lang=js"
export * from "./orderDetail.vue?vue&type=script&lang=js"
import style0 from "./orderDetail.vue?vue&type=style&index=0&id=2dc24957&prod&scoped=true&lang=scss"
import style1 from "./orderDetail.vue?vue&type=style&index=1&id=2dc24957&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc24957",
  null
  
)

export default component.exports